export default ({scale, totalDuration, twoPart, ripple, reverse, delayFactor, lookup, accessor}) => {
  let delays = scale.domain().length

  if (typeof delayFactor === 'undefined') {
    delayFactor = (delays.length > 20 ? .45 : .2) // TODO Maybe a linear scale?
  }

  let delayTime = (totalDuration / delays) * delayFactor
    , divisor = twoPart ? 2 : 1
    , duration = ripple ? (Math.max(0, (totalDuration - (delays * delayTime)) / divisor) + delayTime) : (totalDuration / divisor)

  return {
    duration,
    delay: d => {
      if (!ripple) {
        return 0 // No delay
      }
      let idx = scale.domain().indexOf(d[accessor])

      if (reverse) {
        return Math.abs(idx - delays) * delayTime // Reverses the transitions
      } else {
        return Math.abs(delayTime * idx)
      }
    }
  }
}
